// extracted by mini-css-extract-plugin
module.exports = {"aSelect":"index_aSelect_32kV7"};